import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The kiosk lives on polling; stale data is better than a blank TV.
      staleTime: 0,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});
